import * as React from 'react';
import {
  UNSAFE_NavigationContext as UnsafeNavigateContext
} from 'react-router-dom';
import type { History, Blocker, Transition } from 'history';

export function useBlocker(blocker: Blocker, when = true): void {
  const navigator = React.useContext(UnsafeNavigateContext).navigator as History;

  React.useEffect(() => {
    if (!when) return () => undefined;

    const unblock = navigator.block((tx: Transition) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        }
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when]);
}
